import React, { useState, useEffect } from "react";
import { EpreuvesList2 } from "../EpreuvesList2";
import { loadEpreuves } from "../requests";

const currentYear = new Date().getFullYear();

const ContainerEventsQuery = (props) => {
  const [epreuves, setEpreuves] = useState([]);
  const fetchData = async () => {
    let region = "";

    props.region === "Toute la France"
      ? (region = "")
      : (region = props.region);
    try {
      const epreuvesResult = await loadEpreuves({
        region,
        name: "",
        month: 0,
        year: props.year || currentYear,
        type: props.format,
        relay: props.relay,
        Elevation_bike: props.Elevation_bike,
        Elevation_run: props.Elevation_run,
        bibs: props.bibs,
        Swimenv: props.Swimenv,
        crosstri: props.crosstri,
      });
      setEpreuves(epreuvesResult);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [props]);
  return (
    <div className="container my-2 visible-md">
      {/* Only for smartphone : search engine */}

      {/* left column */}
      <div className="row">
        <div className="col-lg-12">
          <div className="row my-2 font-weight-bold">
            <h6 className="font-weight-bold text-warning">
              {epreuves && epreuves !== undefined && epreuves.length > 1
                ? epreuves.length + " épreuves "
                : epreuves.length + " épreuve "}
              (
              {props.region
                ? props.region + " - " + (props.year || currentYear) + " "
                : "Toute la France"}
              )
            </h6>
          </div>
          <EpreuvesList2
            epreuves={epreuves}
            filterByRegion={props.region}
            remove={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ContainerEventsQuery;
